export default __webpack_public_path__ + "static/P_SearchThumb_InstarVision_Windows-b44d0689b5cc039856b6512485d67560.webp";